function giftItem(state = [], action) {
    switch (action.type) {
      case 'SET_GIFT_ITEM_DATA':
        // let newState = state.concat(action.cartItem);
        const newState = action.giftItem;
        return newState;
  
      default:
        return state;
    }
  }
  
  export default giftItem;
  